<template>
    <div v-if="showFlag" class="flag">
        <div class="fixed flex center middle between">
            <div class="content flex-1">
                <p>
                    <b>Ocorreu um problema com seu pagamento</b>!
                </p>
                <p class="margin-top-s">
                    Faça uma nova assinatura para sua conta. <router-link :to="{ name: 'SubscriptionRedirect' }"><b>clique aqui!</b></router-link>
                </p>
                <p class="margin-top-s">
                    Ou fale com nosso suporte em: <b><a href="https://w.lh4.me/uwqtbp">WhatsApp (41) 98442-1134</a></b> 
                </p>
                <div v-if="false" class="">
                    <div class="button primary margin-top-s" @click="closeMessage()">Fechar</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from "vuex";

export default {
    name: 'subscription-flag-free',
    props: ['show'],
    data() {
        return {
            showFlag: false
        }
    },
    mounted() {
        this.showFlag = this.show
    },
    watch: {
        show() {
            this.showFlag = this.show
        }
    },
    computed: {
        ...mapState({
            account: (state) => state.account,
        }),
    },
    methods: {
        closeMessage() {
            this.$emit('close', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.flag {
    margin-bottom: 60px
}
.fixed {
    position: absolute;
    z-index: 2;
    top: 0px;
    left: 80px;
    width: 100%;
    color: #fff;
    background: rgb(191, 6, 6);
    height: auto;


    .content {
        width: 100%;
        text-align: left;
        font-size: 14px;
        min-height: 70px;
        height: auto;
        padding: 5px 90px 5px 5px;
        text-align: center;
    }

    .icon {
        margin-left: 90px;
        width: 70px;
        padding: 5px;
        font-size: 36px;
    }

    a {
        color: #fff
    }
}

@media screen and (max-width: 1024px) {
   .flag {
        margin-bottom: 110px;
    }
  .fixed {
    left:0px;
    .content {
        padding: 15px 30px 10px 10px;
    }
  }

}
</style>

<style>

@media screen and (max-width: 1024px) {
    .sidebar.isdemo {
        top: 115px !important;
    }
}
</style>
